import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard'
import { AccountRetentionPolicyComponent } from './components/account-retention-policy/account-retention-policy.component'
import { AccountRootComponent } from './components/account-root/account-root.component'
import { AccountShellComponent } from './components/account-shell/account-shell.component'
import { AccountWelcomeComponent } from './components/account-welcome/account-welcome.component'
import { AccountSettingsTabsComponent } from './components/account-settings-tabs/account-settings-tabs.component'
import { AccountGeneralComponent } from './components/account-general/account-general.component'
import { AccountIdentityProvidersComponent } from './components/account-identity-providers/account-identity-providers.component'
import { AccessManagementTabsComponent } from './components/access-management-tabs/access-management-tabs.component'
import { ApplicationDeletedErrorComponent } from './components/application-deleted-error/application-deleted-error.component'
import { ApplicationCreatorAccessMethodPageComponent } from './components/application-creator-access-method-page/application-creator-access-method-page.component'
import { ApplicationCreatorConnectPageComponent } from './components/application-creator-connect-page/application-creator-connect-page.component'
import { ApplicationCreatorDetailsPageComponent } from './components/application-creator-details-page/application-creator-details-page.component'
import { ApplicationCreatorResourcesPageComponent } from './components/application-creator-resources-page/application-creator-resources-page.component'
import { ApplicationCreatorShellComponent } from './components/application-creator-shell/application-creator-shell.component'
import { ApplicationEditorComponent } from './components/application-editor/application-editor.component'
import { ApplicationComponent } from './components/application/application.component'
import { SupportComponent } from './components/support/support.component'
import { ApplicationIssuesComponent } from './components/application-issues/application-issues.component'
import { AccountTagsComponent } from './components/account-tags/account-tags.component'
import { AccountIntegrationsComponent } from './components/account-integrations/account-integrations.component'
import { AccountResourceConfigsComponent } from './components/account-resource-configs/account-resource-configs.component'
import { UserManagementComponent } from './components/user-management/user-management.component'
import { RoleManagementComponent } from './components/role-management/role-management.component'
import { GroupManagementComponent } from './components/group-management/group-management.component'
import { ApiKeyManagementComponent } from './components/api-key-management/api-key-management.component'
import { ProfileComponent } from './components/profile/profile.component'
const routes: Routes = [
  {
    path: ':accountId',
    component: AccountShellComponent,
    children: [
      { path: '', component: AccountRootComponent },
      { path: 'welcome', component: AccountWelcomeComponent },
      { path: 'deleted', component: ApplicationDeletedErrorComponent },
      { path: 'support', component: SupportComponent },
      {
        path: 'applications/new',
        component: ApplicationCreatorShellComponent,
        children: [
          { path: '', component: ApplicationCreatorDetailsPageComponent },
          { path: 'access-method', component: ApplicationCreatorAccessMethodPageComponent },
          { path: 'connect', component: ApplicationCreatorConnectPageComponent },
          { path: 'resources', component: ApplicationCreatorResourcesPageComponent },
        ],
      },
      // New tabbed account settings structure
      {
        path: 'settings/account',
        component: AccountSettingsTabsComponent,
        children: [
          { path: '', component: AccountGeneralComponent },
          { path: 'identity-providers', component: AccountIdentityProvidersComponent },
          { path: 'api-keys', component: ApiKeyManagementComponent },
          { path: 'retention', component: AccountRetentionPolicyComponent },
          { path: 'resources', component: AccountResourceConfigsComponent },
          { path: 'tags', component: AccountTagsComponent },
        ],
      },
      // Legacy route redirects for backwards compatibility
      { path: 'settings/api-key-management', redirectTo: 'settings/account/api-keys', pathMatch: 'full' },
      { path: 'settings/retention', redirectTo: 'settings/account/retention', pathMatch: 'full' },
      { path: 'settings/resources', redirectTo: 'settings/account/resources', pathMatch: 'full' },
      { path: 'settings/user-management', redirectTo: 'settings/access-management', pathMatch: 'full' },
      { path: 'settings/role-management', redirectTo: 'settings/access-management/roles', pathMatch: 'full' },
      { path: 'settings/group-management', redirectTo: 'settings/access-management/groups', pathMatch: 'full' },
      { path: 'settings/tags', redirectTo: 'settings/account/tags', pathMatch: 'full' },
      { path: 'settings/users', redirectTo: 'settings/access-management', pathMatch: 'full' },
      // Access Management tabbed structure
      {
        path: 'settings/access-management',
        component: AccessManagementTabsComponent,
        children: [
          { path: '', component: UserManagementComponent },
          { path: 'roles', component: RoleManagementComponent },
          { path: 'groups', component: GroupManagementComponent },
        ],
      },
      // Other settings routes (not part of tabs)
      { path: 'settings/addons', component: AccountIntegrationsComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'applications/:applicationId', component: ApplicationComponent },
      {
        path: 'applications/:applicationId/configure',
        component: ApplicationEditorComponent,
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'applications/:applicationId/configure/resources',
        component: ApplicationEditorComponent,
        canDeactivate: [UnsavedChangesGuard],
      },
      { path: 'applications/:applicationId/issues', component: ApplicationIssuesComponent },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
